import getQueryList from './getQueryList';

export default function checkIsTicketTypeShownInQuery(ticketTypeReference, query) {
  if (!query.show_tickets) return false;

  return getQueryList(query.show_tickets).includes(ticketTypeReference);
}
